/** Local calendar date (user's browser timezone) for date-picker UX. */
export function todayIsoDate(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function validatePolicyStartDate(date: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return 'Choose when you need your policy to start.';
  }
  if (date < todayIsoDate()) {
    return 'Policy start date cannot be in the past.';
  }
  return null;
}

export function formatPolicyStartDisplay(date: string | null | undefined): string {
  if (!date) return 'Skip for now';
  const iso = date.match(/^(\d{4}-\d{2}-\d{2})/);
  return iso ? iso[1] : date;
}

type PolicyStartDateFieldProps = {
  label: string;
  value: string;
  onChange: (date: string) => void;
  id?: string;
};

export function PolicyStartDateField({ label, value, onChange, id = 'policyStartDate' }: PolicyStartDateFieldProps) {
  const minDate = todayIsoDate();

  return (
    <div className="form-group">
      <label htmlFor={id}>{label} *</label>
      <input
        id={id}
        type="date"
        min={minDate}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        style={{ maxWidth: '16rem' }}
      />
    </div>
  );
}
